import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { ResolveTranslateAbleTextPipe, type TranslateAbleText } from '@pct-ng/i18n';
import type { Icons } from '@pct/icon';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'cappus-loading-button',
  templateUrl: './loading-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressSpinner,
    MatButton,
    ResolveTranslateAbleTextPipe,
    CustomMatSvgIconDirective,
    MatIcon,
  ],
})
export class LoadingButtonComponent {
  readonly loading = input.required<boolean>();

  readonly label = input.required<TranslateAbleText>();

  readonly icon = input<Icons | null>(null);

  readonly type = input<'button' | 'submit' | 'reset' | null>('button');

  readonly textNoWrap = input(true);

  readonly clicked = output();

  onClick(): void {
    this.clicked.emit();
  }
}
